import React, {useEffect, useState} from 'react';
import {agent_promos, agent_promo_remove } from '../../service/promo';
import {agents as getAgents, agent_permission_lookup} from '../../service/agents';
import { getCookie } from '../../utils/shared';

const Promos = ({user_token, set_menu, authorize}) => {

    const [d_view, setDataView] = useState(null);

    let uli_tk = getCookie('agt_usign',true);
    const agent_id = uli_tk["user_id"];

    const [selected_agent, setSelectedAgent] = useState(agent_id);
    const [agents, setAgentOptions] = useState([]);


	const change_agent = (agent_id) => {
		if(agent_id == -1){
			setSelectedAgent(null);
			return
		}
		setSelectedAgent(Number(agent_id));
	}

    useEffect(() =>{

		const ini = async() => {

				const xx = await agent_permission_lookup(user_token, 3)
				if(!xx.result)
				{
					window.location = "/"
				}


				let uli_tk = getCookie('agt_usign',true);

				const agent_id = uli_tk["user_id"];

				// if(uli_tk["user_id"] == 15){
				// 	window.location = "/"
				// }
				// authorize(1);

				let f = "id code expires amount type";

				const lnks = [{'url': '/', 'name': 'Home'}, {'url': '/promo/add', 'name': 'Create Promotional Code'}]
				
				set_menu(lnks)

				let fa = 'id first_name second_name email_address';
				getAgents(user_token, fa, []).then((r) => {

					const aops = [];			
					for(const x of r.agents.result){

						aops.push({"first_name": x.first_name, "second_name":  x.second_name, "id": x.id, "email_address": x.email_address})

					}
					setAgentOptions(aops)
				});

				let x = agent_promos(agent_id, f, user_token).then((r) =>{
					if(r == null){
						return
					}	
					if(r.errors != null){
							if(r.errors.length > 0){
								alert(r.errors[0].message)
								return
							}
							alert("Unexpected Error Contact HWT support...")
							return
					}
					if(r.agent_promotional_codes.error != null){
						alert(r.agent_promotional_codes.error.message)
						return
					}
					setDataView(r.agent_promotional_codes.result)
				}
				);
		}

		ini();


    }, [])


    const filter = () => {
		let f = "id code expires amount type";
		let x = agent_promos(selected_agent, f, user_token).then((r) =>{
			if(r == null){
				return
			}	
			if(r.errors != null){
					if(r.errors.length > 0){
						alert(r.errors[0].message)
						return
					}
					alert("Unexpected Error Contact HWT support...")
					return
			}
			if(r.agent_promotional_codes.error != null){
				alert(r.agent_promotional_codes.error.message)
				return
			}
			setDataView(r.agent_promotional_codes.result)
		});
    }

    const reset_filters = () =>{
        
        let uli_tk = getCookie('agt_usign',true);
        const agent_id = uli_tk["user_id"];
        setSelectedAgent(agent_id);
		let f = "id code expires amount type";

        let x = agent_promos(agent_id, f, user_token).then((r) =>{
			if(r == null){
				return
			}	
			if(r.errors != null){
					if(r.errors.length > 0){
						alert(r.errors[0].message)
						return
					}
					alert("Unexpected Error Contact HWT support...")
					return
			}
			if(r.agent_promotional_codes.error != null){
				alert(r.agent_promotional_codes.error.message)
				return
			}
			setDataView(r.agent_promotional_codes.result)
		});

    }	

	const remove = async (id) => {

        if (window.confirm("This will delete the promo code, are you sure?") === false) {
			return
		}

        let uli_tk = getCookie('agt_usign',true);
        const agent_id = uli_tk["user_id"];

		let f = "id code expires amount type";

		const r = await agent_promo_remove(agent_id, id, f, user_token);
		if(r.errors != null){
			if(r.errors.length > 0){
				alert(r.errors[0].message)
				return
			}
			alert("Unexpected Error Contact HWT support...")
			return
		}
		if(r.agent_promotional_code_remove.error != null){
			alert(r.deposits.error.message)
			return
		}
		setDataView(r.agent_promotional_code_remove.result)
	}


    let filter_agt_ops = null;
	if(agents.length > 0){
		const str_filt_ops = [];





		for(const x of agents){
			let sel = false;
			if(x.id == selected_agent){
				sel = true;
			}
			str_filt_ops.push(<option selected={sel} value={x.id}>{x.first_name} {x.second_name}</option>)
		}

		filter_agt_ops = <div className='filter_field'>
		<div>
			Agents
		</div>
		<div>
			<select onChange={(e) => change_agent(e.target.value) }>
				{str_filt_ops}
			</select>
		</div>
	</div>
	}

    let tbl_view = null;
	if(d_view != null){

        if(d_view.length == 0){
            return (<div>
                <div className='nothing_here'>
                <p>Nothing to see here <br></br>
                   It looks like you have no promotional codes setup. Click <a href='/promo/add'>here</a> to create a one.</p>
                </div>
            </div>)
        }

		let rows = []
		for(let x of d_view){

            let dtype = '';
            if(x.type == 0){
                dtype = '£'
            }
            else{
                dtype = '%'
            }


			rows.push(<tr>
				<td>
					{x.code}
				</td>
				<td>
					{dtype}
				</td>
				<td>
					{x.amount}
				</td>
                <td>
					{x.expires}
				</td>
				<td>
					<a href={'/promo/add?pid=' + x.id}>Edit</a>
				</td>
                <td>
					<a style={{cursor:"pointer", textDecoration:'underline', color:'red'}} onClick={() => remove(x.id)}>Remove</a>
				</td>
			</tr>)
		}

		tbl_view = <table>
				<thead>
					<td>
						Code
					</td>
                    <td>
                        type 
					</td>
                    <td>
                        amount 
					</td>
					<td>
						expires 
					</td>
                    <td></td>
                    <td></td>
				</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	}



    return(
        <div>
				<div className='fitler_sec'>
					{filter_agt_ops}
					<div className='filter_field'>
						<div>
							<button onClick={() => filter()}>Filter</button>
							<button onClick={() => reset_filters()}>Reset</button>
						</div>
					</div>
				</div>
                <div className='rule_tbl'>
                    {tbl_view}
                </div>
        </div>
);


};

export default Promos;